import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"100%","overflow-x":"hidden"} }
const _hoisted_2 = {
  key: 0,
  class: "dataset-name"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"display":"flex","gap":"10px","align-items":"center"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","max-width":"calc(100% - 35px)"} }
const _hoisted_7 = { style: {"width":"100%","max-width":"100%","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-end","overflow":"hidden","align-items":"center","flex":"1"} }
const _hoisted_9 = { class: "file-name" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file" }, null, -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-filter" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "display-pane-checkbox"
}
const _hoisted_16 = {
  key: 1,
  class: "display-pane-item visible"
}
const _hoisted_17 = { style: {"display":"flex","align-items":"center","max-width":"calc(100% - 35px)"} }
const _hoisted_18 = { style: {"width":"100%","max-width":"100%","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"flex-end","overflow":"hidden","align-items":"center","flex":"1"} }, null, -1)
const _hoisted_20 = { class: "display-pane-option" }
const _hoisted_21 = {
  key: 2,
  class: "display-pane-empty"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sliders-h" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "please-load-data"
}
const _hoisted_24 = { class: "display-pane-empty" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_checkbox = _resolveComponent("imdex-checkbox")!
  const _component_imdex_switch = _resolveComponent("imdex-switch")!
  const _component_imdex_threshold_filter_manager = _resolveComponent("imdex-threshold-filter-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loadingState)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["display-pane-inner", { disabled: !_ctx.hasDataLoaded && _ctx.displayMethods.length > 0 }])
        }, [
          (_ctx.activeDataset != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  style: {"width":"15px"},
                  src: 
						_ctx.activeDataset.isGAS
							? _ctx.$data['ioGAS']
							: _ctx.$data[_ctx.activeDataset.dataType as keyof typeof $data]
					,
                  alt: ""
                }, null, 8, _hoisted_3),
                _createTextVNode(_toDisplayString(_ctx.activeDataset.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMethods.sort(_ctx.sortOnBlockSortOrder), (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.activateLayer(item)),
              key: i + _ctx.activeView,
              class: _normalizeClass(["display-pane-item", {
					visible: item.visible,
					active: item.layerName == _ctx.activeStore.SSA_ACTIVE_LAYER
				}])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_imdex_checkbox, {
                    class: _normalizeClass({
								disabled: item.disabled || false
							}),
                    onClick: _withModifiers(($event: any) => (
								_ctx.loadParaviewData(item),
									item.selected && !item.open ? _ctx.activateLayer(item) : null
							), ["stop"]),
                    secondary: "",
                    value: item.selected,
                    "onUpdate:value": ($event: any) => ((item.selected) = $event)
                  }, null, 8, ["class", "onClick", "value", "onUpdate:value"]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(item.fileName.split(".")[0]), 1)
                  ])
                ]),
                (_ctx.filtersLayerMap[item.layerName])
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "display-pane-filter-exists",
                      onClick: _withModifiers(($event: any) => {
							item.layerName !== _ctx.activeStore.SSA_ACTIVE_LAYER
								? _ctx.activateLayer(item)
								: null;
							_ctx.filtersStore.SSA_FILTERS_ICON_CLICKED(item.layerName);
						}, ["stop"])
                    }, _hoisted_13, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                (
							item.configuration != null &&
							item.configuration.filter(
								(item2) => item2.visible == null || item2.visible == true
							).length > 0
						)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      class: "display-pane-expand"
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fal", { 'fa-plus': !item.open, 'fa-minus': item.open }]),
                        onClick: ($event: any) => (_ctx.activateLayer(item))
                      }, null, 10, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["display-pane-configuration", {
						disabled: !item.selected,
						empty:
							item.configuration &&
							item.configuration.filter((item) => item.visible).length == 0
					}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.configuration, (configOption, p) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "display-pane-option",
                    key: p
                  }, [
                    _withDirectives(_createElementVNode("div", null, [
                      (configOption.type == 'checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_imdex_switch, {
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                              value: configOption.value,
                              "onUpdate:value": ($event: any) => ((configOption.value) = $event),
                              onChange: ($event: any) => (_ctx.runOnChangeFunction($event, configOption)),
                              label: configOption.label
                            }, null, 8, ["value", "onUpdate:value", "onChange", "label"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, 
								configOption.type != 'component' &&
								configOption.visible != null &&
								configOption.visible != false
							]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(configOption.component), {
                      visualized: item.selected,
                      open: item.open,
                      datasetType: 
								_ctx.activeStore.SSA_ACTIVE_DATASET &&
								_ctx.activeStore.SSA_ACTIVE_DATASET.dataType.toLowerCase()
							,
                      active: item.layerName == _ctx.activeStore.SSA_ACTIVE_LAYER,
                      hierarchyLayerSelections: _ctx.hierarchyLayerSelections,
                      config: {
								...configOption,
								...item,
								isBlastdog: _ctx.isBlastdog,
								isGAS: _ctx.isGAS,
								hasDataLoaded: _ctx.hasDataLoaded >= 1
							},
                      onClick: _withModifiers(_ctx.fireWindowClick, ["stop"])
                    }, null, 8, ["visualized", "open", "datasetType", "active", "hierarchyLayerSelections", "config", "onClick"])), [
                      [_vShow, configOption.type == 'component']
                    ])
                  ]))
                }), 128))
              ], 2), [
                [_vShow, item.open]
              ])
            ], 10, _hoisted_4))
          }), 128)),
          (_ctx.activeDataset && _ctx.activeDataset.dataType != ('Surface' as DatasetType))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setFiltersOpen(!_ctx.openFiltersTmp))),
                  style: {"display":"flex","gap":"10px","align-items":"center"}
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_imdex_checkbox, {
                      disabled: _ctx.isFiltersDisabled,
                      secondary: "",
                      value: _ctx.selectFiltersTmp,
                      "onUpdate:value": _ctx.selectFiltersClicked,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["disabled", "value", "onUpdate:value"]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("ssa.displayPane.filters")), 1)
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    class: "display-pane-expand"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fal", {
								'fa-plus': !_ctx.openFiltersTmp,
								'fa-minus': _ctx.openFiltersTmp
							}]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFiltersOpen(!_ctx.openFiltersTmp)))
                    }, null, 2)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["display-pane-configuration", {
						disabled: !_ctx.selectFiltersTmp,
						empty: false
					}])
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_imdex_threshold_filter_manager, { "activate-layer": _ctx.activateLayer }, null, 8, ["activate-layer"])
                  ])
                ], 2), [
                  [_vShow, _ctx.openFiltersTmp]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.displayMethods.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("ssa.displayPane.selectToChange")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.hasDataLoaded && _ctx.displayMethods.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("ssa.displayPane.highlightedNotSelected")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}